export default "__VITE_ASSET__Cl38XkVi__"